import {QueryParamType} from '../routing.enums';
import type {QueryParamDef} from '../routing.types';

function parseQueryParam(
  paramValue: string | string[],
  paramDef: QueryParamDef,
): string | number | string[] | number[] {
  const {type} = paramDef;

  if (type === QueryParamType.String) {
    return Array.isArray(paramValue) ? paramValue[0] : paramValue;
  }

  if (type === QueryParamType.Number) {
    const valueToConvert = Array.isArray(paramValue) ? paramValue[0] : paramValue;
    const numValue = Number(valueToConvert);

    if (isNaN(numValue)) {
      throw new Error(
        `Invalid number value "${valueToConvert}" for query parameter "${paramDef.key}"`,
      );
    }

    return numValue;
  }

  if (type === QueryParamType.Boolean) {
    const valueToConvert = Array.isArray(paramValue) ? paramValue[0] : paramValue;

    // Convert boolean to string representation for compatibility with AppRouteQueryParams
    return valueToConvert === 'true' ? 'true' : 'false';
  }

  if (type === QueryParamType.OneOf) {
    const valueToCheck = Array.isArray(paramValue) ? paramValue[0] : paramValue;

    if (paramDef.enumValues && !paramDef.enumValues.includes(valueToCheck)) {
      throw new Error(
        `Invalid enum value "${valueToCheck}" for query parameter "${paramDef.key}". Expected one of: ${paramDef.enumValues.join(', ')}`,
      );
    }

    return valueToCheck;
  }

  if (type === QueryParamType.OneOrMoreOf) {
    let valuesToCheck: string[];

    if (Array.isArray(paramValue)) {
      // Handle multiple query parameters with same key
      valuesToCheck = paramValue;
    } else {
      // Handle comma-separated string
      valuesToCheck = paramValue.split(',').map((value) => value.trim());
    }

    if (paramDef.enumValues) {
      for (const value of valuesToCheck) {
        if (!paramDef.enumValues.includes(value)) {
          throw new Error(
            `Invalid enum value "${value}" for query parameter "${paramDef.key}". Expected one of: ${paramDef.enumValues.join(', ')}`,
          );
        }
      }
    }

    // Always return as array of strings
    return valuesToCheck;
  }

  // Default case - return as string
  return Array.isArray(paramValue) ? paramValue[0] : paramValue;
}

export default parseQueryParam;
